import type {
	CustomItem,
	DropButtonType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropButton = (
	item: Item | CustomItem
): item is DropButtonType => {
	return !!(item && item.__typename === 'Drop_Button');
};
